import { Partners } from '@shared/enums/partners.enum';
import { XPartnerService } from './../../../../../../shared/services/x-partner.service';
import { Component, HostBinding } from '@angular/core';
import { Config } from '@shared/configs/config';
import { NavigateService } from '@core/routes/services/navigate.service';
import { BasePanelService } from '@modules/base-panel/pages/base-panel/services/base-panel.service';
import { UserService } from '@shared/services/user.service';

@Component({
  selector: 'df-base-logo',
  templateUrl: './base-logo.component.html',
  styleUrls: ['./base-logo.component.scss'],
})
export class BaseLogoComponent {
  Config = Config;

  @HostBinding('class.short')
  get short() {
    return this.basePanelService?.routeData?.shortLeftNavigation;
  }

  @HostBinding('class.oxford-menu')
  get oxfordMenu() {
    return this.xPartnerService.partnerName === Partners.OXFORD_IE;
  }

  constructor(
    public n: NavigateService,
    public basePanelService: BasePanelService,
    public userService: UserService,
    public xPartnerService: XPartnerService,
  ) {}
}
